import { render, staticRenderFns } from "./JobCancel.vue?vue&type=template&id=2b8c1aeb&scoped=true&"
import script from "./JobCancel.vue?vue&type=script&lang=js&"
export * from "./JobCancel.vue?vue&type=script&lang=js&"
import style0 from "./JobCancel.vue?vue&type=style&index=0&id=2b8c1aeb&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c1aeb",
  null
  
)

export default component.exports